<style scoped lang="scss">
textarea {
  min-height: 10rem;
}
.nav-pills .nav-item .nav-link.active {
  background-color: #007bff;
  border-radius: 0.25rem !important;
}
.nav-pills .nav-item .nav-link {
  border: 0px solid #007bff;
}
.nav.nav-pills {
  margin-bottom: 10px;
}
</style>

<template>
  <section>
    <div class="card">
      <div class="card-header">
        <h4>Einstellungen</h4>
      </div>
      <div class="card-body">
        <ul class="nav nav-pills" id="myTab" role="tablist">
          <li class="nav-item">
            <a
              class="nav-link active"
              data-toggle="tab"
              href="#telegram"
              role="tab"
              >Telegram</a
            >
          </li>
        </ul>
        <div class="tab-content" id="myTabContent">
          <div class="tab-pane fade show active" id="telegram" role="tabpanel">
            <div class="form-group row">
              <col-label>Täglicher Bonus</col-label>
              <div class="col-8">
                <div class="custom-control custom-checkbox">
                  <input
                    class="form-check-input custom-control-input"
                    type="checkbox"
                    v-model="data.telegramDailyBonus"
                    id="telegramDailyBonus"
                  />
                  <label
                    class="form-check-label custom-control-label"
                    for="telegramDailyBonus"
                    >aktiv</label
                  >
                </div>
              </div>
            </div>
            <div class="form-group row">
              <col-label>Täglicher Bonus Menge</col-label>
              <div class="col-8">
                <input
                  type="number"
                  class="form-control"
                  v-model="data.telegramDailyBonusAmount"
                />
              </div>
            </div>
            <div class="form-group row">
              <col-label>Täglicher Bonus Text</col-label>
              <div class="col-8">
                <textarea
                  class="form-control"
                  v-model="data.telegramDailyBonusAnswer"
                ></textarea>
              </div>
            </div>
            <hr />
            <div class="form-group row">
              <col-label>Registrationsbonus</col-label>
              <div class="col-8">
                <div class="custom-control custom-checkbox">
                  <input
                    class="form-check-input custom-control-input"
                    type="checkbox"
                    v-model="data.telegramVerificationBonus"
                    id="telegramVerificationBonus"
                  />
                  <label
                    class="form-check-label custom-control-label"
                    for="telegramVerificationBonus"
                    >aktiv</label
                  >
                </div>
              </div>
            </div>
            <div class="form-group row">
              <col-label>Registrationsbonus Menge</col-label>
              <div class="col-8">
                <input
                  type="number"
                  class="form-control"
                  v-model="data.telegramVerificationBonusAmount"
                />
              </div>
            </div>
            <hr />
            <blockquote class="blockquote">
              <div class="row">
                <div class="col-6">
                  verfügbare Platzhalter:
                  <table class="table">
                    <thead>
                      <tr>
                        <th>
                          Platzhalter
                        </th>
                        <th>
                          Ausgabe
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          {customer-name}
                        </td>
                        <td>
                          Name des Kunden
                        </td>
                      </tr>
                      <tr>
                        <td>
                          {customer-coins}
                        </td>
                        <td>anzahl der aktuellen {{ currency }}</td>
                      </tr>
                      <tr>
                        <td>
                          {currency}
                        </td>
                        <td>
                          {{ currency }}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          {customer-unread-messages}
                        </td>
                        <td>
                          anzahl der ungelesenen Nachrichten
                        </td>
                      </tr>
                      <tr>
                        <td>
                          {customer-friends-online}
                        </td>
                        <td>
                          anzahl der Freunde welche online sind
                        </td>
                      </tr>
                      <tr>
                        <td>
                          {customer-profile-visits}
                        </td>
                        <td>
                          anzahl der ungelesenen Profil besuche
                        </td>
                      </tr>
                      <tr>
                        <td>
                          {website}
                        </td>
                        <td>
                          {{ domains }}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          {next-daily-bonus}
                        </td>
                        <td>
                          Datum nächst möglicher Bonus: DD.MM.YYYY um HH:MM:SS
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="col-6">
                  verfügbare Markup tags
                  <table class="table">
                    <thead>
                      <tr>
                        <th>
                          Tag
                        </th>
                        <th>
                          Ausgabe
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          &lt;u&gt;Lorem ipsum&lt;/u&gt;
                        </td>
                        <td>
                          <u>Lorem ipsum</u>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          &lt;b&gt;Lorem ipsum&lt;/b&gt;
                        </td>
                        <td>
                          <b>Lorem ipsum</b>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          &lt;i&gt;Lorem ipsum&lt;/i&gt;
                        </td>
                        <td>
                          <i>Lorem ipsum</i>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          &lt;s&gt;Lorem ipsum&lt;/s&gt;
                        </td>
                        <td>
                          <s>Lorem ipsum</s>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          &lt;code&gt;Lorem ipsum&lt;/code&gt;
                        </td>
                        <td>
                          <code>Lorem ipsum</code>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          &lt;a href="{{ domains }}"&gt;Lorem ipsum&lt;/a&gt;
                        </td>
                        <td>
                          <a :href="domains">Lorem ipsum</a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </blockquote>
          </div>
          <div class="form-group">
            <button @click="persist()" class="btn btn-primary">
              Speichern
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  created() {
    this.$store.dispatch("setting/all").then(() => {
      const settings = this.$store.getters["setting/all"];
      Object.keys(settings).forEach(key => {
        this.data[key] = settings[key];
      });
    });
  },
  methods: {
    persist() {
      const data = Object.assign({}, this.data);
      this.$store.dispatch("setting/update", data).then(() => {
        this.$notify({
          title: "Einstellungen gespeichert",
          type: "success"
        });
      });
    }
  },
  computed: {
    telegram() {
      return this.data.telegram == 1;
    },
    domains() {
      return Laravel.domains[0];
    },
    currency() {
      return Laravel.lang.currency;
    }
  },
  data() {
    return {
      telegramError: false,
      data: {
        telegram: 0,
        telegramDailyBonus: 0,
        telegramDailyBonusAmount: 1,
        telegramVerificationBonus: 0,
        telegramVerificationBonusAmount: 10,
        telegramDailyBonusAnswer: ""
      }
    };
  }
};
</script>
